import { UserState, Buddy, ChatMessage } from '../types.ts';

const KEYS = {
  USER: 'sobu_user_v1',
  BUDDIES: 'sobu_buddies_v1',
  CHATS: 'sobu_chats_v1',
};

export const saveUser = (user: UserState) => {
  try {
    localStorage.setItem(KEYS.USER, JSON.stringify(user));
  } catch (e) {
    console.error("Failed to save user", e);
  }
};

export const loadUser = (): UserState | null => {
  try {
    const data = localStorage.getItem(KEYS.USER);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
};

export const saveBuddies = (buddies: Buddy[]) => {
  try {
    localStorage.setItem(KEYS.BUDDIES, JSON.stringify(buddies));
  } catch (e) {
    console.error("Failed to save buddies", e);
  }
};

export const loadBuddies = (): Buddy[] => {
  try {
    const data = localStorage.getItem(KEYS.BUDDIES);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
};

export const saveChats = (chats: Record<string, ChatMessage[]>) => {
  try {
    localStorage.setItem(KEYS.CHATS, JSON.stringify(chats));
  } catch (e) {
    console.error("Failed to save chats", e);
  }
};

export const loadChats = (): Record<string, ChatMessage[]> => {
  try {
    const data = localStorage.getItem(KEYS.CHATS);
    return data ? JSON.parse(data) : {};
  } catch (e) {
    return {};
  }
};

export const clearData = () => {
  localStorage.removeItem(KEYS.USER);
  localStorage.removeItem(KEYS.BUDDIES);
  localStorage.removeItem(KEYS.CHATS);
};